import React from "react";
import { Classes as BpClasses } from "@blueprintjs/core";
import { IHeaderPartProps} from "../../models";
import { getAlignmentClass } from "../../models/utils";
import classnames from "classnames";
import css from "../../form.module.scss"
import MergedContent from "./MergedContent";


const HeaderPart = ({alignment, style, size, content} : IHeaderPartProps ) => {
  const alignmentClass = getAlignmentClass(alignment);
  const className = classnames(css.formPart, alignmentClass, BpClasses.RUNNING_TEXT);
  return (
    <MergedContent content={content}>
      {(content) => {
        const header = React.createElement(size, undefined, content);
        return <div style={style} className={className}>{header}</div>;
      }}
    </MergedContent>
  );
}

export default HeaderPart;






